import themes from "daisyui/src/theming/themes.js";
import { ConfigProps } from "./types/config";

const config = {
  // REQUIRED
  appName: "ai-about.me",
  appTitle: "ai-about.me powered by AI",
  // REQUIRED: a short description of your app for SEO tags (can be overwritten)
  appDescription:
    "ai-about.me powered by AI",
  // REQUIRED (no https://, not trialing slash at the end, just the naked domain)
  domainName: "ai-about.me",
  crisp: {
    // Crisp website ID. IF YOU DON'T USE CRISP: just remove this => Then add a support email in this config file (mailgun.supportEmail) otherwise customer support won't work.
    id: "",
    // Hide Crisp by default, except on route "/". Crisp is toggled with <ButtonSupport/>. If you want to show Crisp on every routes, just remove this below
    onlyShowOnRoutes: ["/"],
  },
  stripe: {
    // Create multiple plans in your Stripe dashboard, then add them here. You can add as many plans as you want, just make sure to add the priceId
    plans: [
      {
        // REQUIRED — we use this to find the plan in the webhook (for instance if you want to update the user's credits based on the plan)
        priceId:
          process.env.NODE_ENV === "development"
            ? "price_1Niyy5AxyNprDp7iZIqEyD2h"
            : "price_456",
        //  REQUIRED - Name of the plan, displayed on the pricing page
        name: "Starter",
        // A friendly description of the plan, displayed on the pricing page. Tip: explain why this plan and not others
        description: "Perfect for small projects",
        // The price you want to display, the one user will be charged on Stripe.
        price: 99,
        // If you have an anchor price (i.e. $29) that you want to display crossed out, put it here. Otherwise, leave it empty
        priceAnchor: 149,
        features: [
          {
            name: "NextJS boilerplate",
          },
          { name: "User oauth" },
          { name: "Database" },
          { name: "Emails" },
        ],
      },
      {
        priceId:
          process.env.NODE_ENV === "development"
            ? "price_1O5KtcAxyNprDp7iftKnrrpw"
            : "price_456",
        // This plan will look different on the pricing page, it will be highlighted. You can only have one plan with isFeatured: true
        isFeatured: true,
        name: "Advanced",
        description: "You need more power",
        price: 149,
        priceAnchor: 299,
        features: [
          {
            name: "NextJS boilerplate",
          },
          { name: "User oauth" },
          { name: "Database" },
          { name: "Emails" },
          { name: "1 year of updates" },
          { name: "24/7 support" },
        ],
      },
    ],
  },
  aws: {
    // If you use AWS S3/Cloudfront, put values in here
    bucket: "bucket-name",
    bucketUrl: `https://bucket-name.s3.amazonaws.com/`,
    cdn: "https://cdn-id.cloudfront.net/",
  },
  mailgun: {
    // subdomain to use when sending emails, if you don't have a subdomain, just remove it. Highly recommended to have one (i.e. mg.yourdomain.com or mail.yourdomain.com)
    subdomain: "mg",
    // REQUIRED — Email 'From' field to be used when sending magic login links
    fromNoReply: `AIToolly <support@ai-about.me>`,
    // REQUIRED — Email 'From' field to be used when sending other emails, like abandoned carts, updates etc..
    fromAdmin: `Andy at AIToolly <support@ai-about.me>`,
    // Email shown to customer if need support. Leave empty if not needed => if empty, set up Crisp above, otherwise you won't be able to offer customer support."
    supportEmail: "support@AIToolly.com",
    // When someone replies to supportEmail sent by the app, forward it to the email below (otherwise it's lost). If you set supportEmail to empty, this will be ignored.
    forwardRepliesTo: "support@AIToolly.com",
  },
  colors: {
    // REQUIRED — The DaisyUI theme to use (added to the main layout.js). Leave blank for default (light & dark mode). If you any other theme than light/dark, you need to add it in config.tailwind.js in daisyui.themes.
    theme: "light",
    // REQUIRED — This color will be reflected on the whole app outside of the document (loading bar, Chrome tabs, etc..). By default it takes the primary color from your DaisyUI theme (make sure to update your the theme name after "data-theme=")
    // OR you can just do this to use a custom color: main: "#f37055". HEX only.
    main: themes[`[data-theme=light]`]["primary"],
  },
  auth: {
    // REQUIRED — the path to log in users. It's use to protect private routes (like /dashboard). It's used in apiClient (/libs/api.js) upon 401 errors from our API
    loginUrl: "/signin",
    // REQUIRED — the path you want to redirect users after successfull login (i.e. /dashboard, /private). This is normally a private page for users to manage their accounts. It's used in apiClient (/libs/api.js) upon 401 errors from our API & in ButtonSignin.js
    callbackUrl: "/dashboard",
  },
  lemonsqueezy: {
    // Create a product and add multiple variants via your Lemon Squeezy dashboard, then add them here. You can add as many plans as you want, just make sure to add the variantId.
    plans: [
      // {
      //   variantId:
      //     process.env.NODE_ENV === "development"
      //       ? "0"
      //       : "0",
      //   // This plan will look different on the pricing page, it will be highlighted. You can only have one plan with isFeatured: true.
      //   isFeatured: false,
      //   name: "Free",
      //   description: "Need Add AIToolly to your homepage, then submit your website for free.",
      //   price: 0,
      //   // priceAnchor: 0,
      //   features: [
      //     { name: "Review in 48 hours" },
      //     { name: "Get dofollow link" },
      //     { name: "Listing on website forever" },
      //     { name: "No featured style" },
      //   ],
      // },
      // {
      //   // REQUIRED — we use this to find the plan in the webhook (for instance if you want to update the user's credits based on the plan)
      //   variantId:
      //     process.env.NODE_ENV === "development"
      //       ? "505920"
      //       : "513761",
      //   //  REQUIRED - Name of the plan, displayed on the pricing page
      //   name: "AIToolly Submit Pack",
      //   // A friendly description of the plan, displayed on the pricing page. Tip: explain why this plan and not others.
      //   // description: "Perfect for small projects",
      //   // The price you want to display, the one user will be charged on Lemon Squeezy
      //   price: 9.99,
      //   // If you have an anchor price (i.e. $149) that you want to display crossed out, put it here. Otherwise, leave it empty.
      //   priceAnchor: 29.9,
      //   description: "Submit 1 site without backlink to get dofollow link and featured!",
      //   features: [
      //     { name: "Review in 24 hours" },
      //     { name: "Get dofollow link" },
      //     { name: "Listing on website forever" },
      //     { name: "Get featured style" },
      //   ],
      // },
    ],
  },
} as ConfigProps;

export default config;
